import React, { useEffect, useState } from "react";
import { client } from "@/lib/api";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from "@/components/ui/dialog";

const fmtDate = value => new Date(`${value}T12:00:00Z`).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });

export function useAppVersion() {
  const [version, setVersion] = useState("");
  useEffect(() => {
    client.get("/version").then(r => setVersion(r.data.version)).catch(() => setVersion(""));
  }, []);
  return version;
}

export function WhatsNewDialog({ open, onOpenChange }) {
  const [notes, setNotes] = useState([]);
  useEffect(() => {
    if (!open) return;
    client.get("/release-notes").then(r => setNotes(r.data)).catch(() => setNotes([]));
  }, [open]);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[560px] max-h-[85vh] overflow-y-auto" data-testid="whats-new-dialog">
        <DialogHeader>
          <DialogTitle>What's new</DialogTitle>
          <DialogDescription>Every release of Blueflames Service Pro, newest first.</DialogDescription>
        </DialogHeader>
        <div className="space-y-5">
          {notes.map(release => (
            <section key={release.version} data-testid={`release-${release.version}`}>
              <div className="flex items-baseline gap-2 flex-wrap">
                <span className="mono text-[13px] font-semibold">v{release.version}</span>
                <span className="text-[12px]" style={{ color: "#5B6472" }}>{fmtDate(release.date)}</span>
              </div>
              <div className="text-[14px] font-semibold mt-0.5">{release.title}</div>
              <ul className="mt-1.5 space-y-1 list-disc pl-5 text-[13px]" style={{ color: "#3A4250" }}>
                {release.changes.map(change => <li key={change}>{change}</li>)}
              </ul>
            </section>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}

export function VersionTag({ version, canOpen, onOpen, className = "" }) {
  if (!version) return null;
  const style = { color: "#8A93A1" };
  if (!canOpen) {
    return <div className={`mono text-[11px] ${className}`} style={style} data-testid="app-version">v{version}</div>;
  }
  return (
    <button type="button" className={`mono text-[11px] hover:underline ${className}`} style={style}
            onClick={onOpen} title="What's new" data-testid="app-version">
      v{version}
    </button>
  );
}
